import { HpDispatchFunction } from '../types';
import { HpHelpClickPayload } from './helpClickActionTypes';

export function helpClickAction(payload: HpHelpClickPayload) {
  return (dispatch: HpDispatchFunction<HpHelpClickPayload>): void => {
    dispatch({ type: 'HELP_CLICK', payload });
  };
}
